import React from 'react';
import Button from '../../../../component/ui/Button';
import { hasPermission } from '../../../../utils/controller';

function CreatePurchaseBillHeader({
	id,
	user,
	navigate,
	suburl,
	loading,
	setIsPurchaseBillAutoSave,
	handleUpdatePurchaseBill,
	handleSavePurchaseBill,
}) {
	return (
		<div className="header-position-sticky">
			<div className="product-pg-header">
				<p>
					{id && !id.includes('ytr') && !id.includes('por') && !id.includes('pr')
						? 'Update '
						: 'Create New '}
					Purchase Bill
				</p>
				<div className="add-product-button">
					<Button
						type="button"
						className="btn-primary mt-0 px-4"
						disabled={
							loading?.status === 1 && loading.isLoading
								? true
								: id && !id.includes('ytr') && !id.includes('por') && !id.includes('pr')
									? !hasPermission('purchases.purchase_bills.edit', user?.role?.role_permissions)
									: !hasPermission('purchases.purchase_bills.create', user?.role?.role_permissions)
						}
						button="Save"
						loader={loading?.status === 1 && loading.isLoading}
						onClick={() => {
							setIsPurchaseBillAutoSave(false);
							if (id && !id.includes('ytr') && !id.includes('por') && !id.includes('pr')) {
								handleUpdatePurchaseBill(1);
							} else {
								handleSavePurchaseBill(1);
							}
						}}
					/>
					<Button
						type="button"
						className="btn-primary mt-0 px-4"
						button="Save as Draft"
						disabled={
							loading?.status === 0 && loading.isLoading
								? true
								: id && !id.includes('ytr') && !id.includes('por') && !id.includes('pr')
									? !hasPermission('purchases.purchase_bills.edit', user?.role?.role_permissions)
									: !hasPermission('purchases.purchase_bills.create', user?.role?.role_permissions)
						}
						loader={loading?.status === 0 && loading.isLoading}
						onClick={() => {
							setIsPurchaseBillAutoSave(false);
							if (id && !id.includes('ytr') && !id.includes('por') && !id.includes('pr')) {
								handleUpdatePurchaseBill(0);
							} else {
								handleSavePurchaseBill(0);
							}
						}}
					/>
					<Button
						type="button"
						className="mt-0 btn-danger add-pro"
						button=""
						close
						onClick={() => navigate(`/user/${suburl}/purchases-bills`)}
					/>
				</div>
			</div>
		</div>
	);
}

export default CreatePurchaseBillHeader;
